import type { MonospaceUserOrgRole } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';

// Single organization role assignment for a MonospaceUser.
// Consumed via the `orgRole` include on MonospaceUser
export const UserOrgRole = withItemType<MonospaceUserOrgRole>().defineCollection({
	name: 'MonospaceUserOrgRole',
	scopeId: MONOSPACE_SCOPE_ID,
	getKey: (item) => item.userId,
	meta: {
		defaultFields: ['userId', 'orgRoleId'],
	},
});
